// What Download saves: the signed URL (doc_path itself isn't publicly
// readable), or for a file picked this session — which has no signed URL
// until get_docs is read again — the local copy of that file.
export const docFileUrl = (d) => (d && (d.signedUrl || d.localUrl)) || null;

// Saves a document. The bucket is cross-origin, where <a download> is
// ignored, so the file is fetched as a blob first; if that's blocked (CORS,
// or a WebView without blob downloads) it's opened in a new tab instead.
export const downloadFile = async (url, name) => {
  if (!url) return;
  const fileName = name || decodeURIComponent(url.split("?")[0].split("/").pop() || "document");
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("HTTP " + res.status);
    const blobUrl = URL.createObjectURL(await res.blob());
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  } catch (err) {
    window.open(url, "_blank", "noopener");
  }
};
